import React, {Component} from 'react';
import {Redirect} from 'components/ReactRouterDomLocalized';
const { connect } = require('react-redux');
import Modal from 'react-bootstrap-modal';

import LoginRedirect from 'components/LoginRedirect';
import {Form, ErrorContainer} from 'form';

import '../../sass/modals/ModalAddGuestbookMessage.scss';

import {t} from 'l10n';

import {addGuestbookMessage} from 'backend-helpers/member';
import {memberGuestbookMessageAdded} from 'reducers/member';
import ModalBlacklisted from './ModalBlacklisted';

class ModalAddGuestbookMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pending: false,
            faq: false
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        if (this.state.pending) return false;

        let {memberGuestbookMessageAdded, user, closeFn} = this.props;

        this.setState({pending: true});

        addGuestbookMessage(formData)
            .then(({guestbookMessage}) => {
                memberGuestbookMessageAdded({guestbookMessage, user});
                this.setState({pending: false});
                closeFn();
            })
            .catch((error) => {
                this.setState({pending: false});
                setErrors(error.messages || error.message)
            });
    }

    render() {
        let {show, closeFn, currentUser, user, blacklistedMe, returnPath} = this.props;

        if (!show) return null;

        if (!currentUser.isLoggedIn()) {
            return <LoginRedirect returnPath={returnPath}/>
        }

        if (blacklistedMe) {
            return <ModalBlacklisted show={show} closeFn={closeFn} user={user}/>;
        }

        return (
            <div>
                <Modal className="modalAddGuestbookMessage" show={show} onHide={closeFn}>
                    <Modal.Body>
                        <div className="close" onClick={closeFn}></div>

                        <div className="form">
                            <Form onSubmit={this.onSubmit}>
                                <ErrorContainer data-errorcontainer={true} />

                                <input type="hidden" name="recipient_id" value={user.id}/>

                                <div className="form-group">
                                    <label className="mini">{t('Add message to guestbook of %1', user.nick)}</label>
                                    <textarea name="message"></textarea>
                                </div>

                                <div className="form-group">
                                    <div className="buttons">
                                        <button type="submit" className={'send' + (this.state.pending ? ' loading' : '')}>{t('Send')}</button>
                                        <button type="button" className="cancel" onClick={closeFn}>{t('Cancel')}</button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default connect(
    null,
    {
        memberGuestbookMessageAdded: memberGuestbookMessageAdded
    }
)(ModalAddGuestbookMessage);


// WEBPACK FOOTER //
// ./src/components/modals/ModalAddGuestbookMessage.js